import $ from 'jquery'
import tippy from 'tippy.js'
import Cookies from 'js-cookie';

tippy('[data-tippy-content]')

const jsContainer = () => {
  if ($('.js-container').length) {
    // let bodyWidth = '100%'
    // let ml = 0

    // if (win / dow.matchMedia('(min-width: 1200px)').matches) {
    const bodyWidth = $('#primary').width()
    const ml = `calc(${-bodyWidth / 2}px + 50%)`
    // }

    $('.js-container').css({
      width: bodyWidth,
      marginLeft: ml,
    })
  }
}

$(window)
  .on('resize', function () {
    jsContainer()
  })
  .trigger('resize')

$('.notification-closer').click(function (e) {
  e.preventDefault();

  const parent = $(this).parents('.site-notification');
  const ver = parent.attr('data-ver');

  Cookies.set('notificationDisabled', ver);

  parent.addClass('site-notification--hidden').slideToggle('fast', headerPadding);
});

const headerPadding = () => {
  const headerHeight = $('.site-header').outerHeight();
  $('.site-wrapper').css('padding-top', headerHeight);
};
